import styled from "styled-components";
export const ExpanderContainer = styled.div.withConfig({
  displayName: "expanderstyles__ExpanderContainer",
  componentId: "sc-il79bj-0"
})(["", ""], {
  display: "flex",
  flexDirection: "column"
});
export const ExpanderTitleContainer = styled.div.withConfig({
  displayName: "expanderstyles__ExpanderTitleContainer",
  componentId: "sc-il79bj-1"
})(["", " ", ""], ({
  disabled
}) => disabled ? {
  opacity: "0.5",
  cursor: "not-allowed"
} : {
  cursor: "pointer"
}, {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center"
});
export const ExpanderChildContainer = styled.div.withConfig({
  displayName: "expanderstyles__ExpanderChildContainer",
  componentId: "sc-il79bj-2"
})(["", ""], ({
  isOpen
}) => isOpen ? {
  display: "flex",
  marginTop: "0.5rem"
} : {
  display: "none"
});
